import { STATUS_LABEL, PAY_LABEL } from "@/lib/api";

const S = {
  confirmed: "bg-green-100 text-green-800", pending: "bg-yellow-100 text-yellow-800",
  cancelled: "bg-red-100 text-red-700", no_show: "bg-slate-200 text-slate-700",
};
const P = { paid: "text-green-700", paid_at_channel: "text-green-700", failed: "text-red-600", expired: "text-red-600" };

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-flex rounded px-2 py-0.5 text-xs font-semibold ${S[status] || "bg-slate-100"}`}>{STATUS_LABEL[status] || status}</span>
);

export const PayText = ({ status }) => <span className={`text-xs font-medium ${P[status] || "text-slate-500"}`}>{PAY_LABEL[status] || status}</span>;

export const SOURCE_LABEL = (s) => (s === "direct" ? "Website" : s === "demo" ? "Website" : s?.replace(/_/g, " ") || "-");

export const Panel = ({ title, action, children, className = "", testid }) => (
  <section data-testid={testid} className={`rounded-lg border border-slate-200 bg-white ${className}`}>
    {title && (
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-3">
        <h3 className="font-ex-heading text-base font-bold">{title}</h3>{action}
      </div>
    )}
    {children}
  </section>
);
